import { render } from "./PinPage.vue?vue&type=template&id=f3b30cba"
import script from "./PinPage.vue?vue&type=script&lang=js"
export * from "./PinPage.vue?vue&type=script&lang=js"

import "./PinPage.vue?vue&type=style&index=0&id=f3b30cba&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__